/**
 * Container for Search component with modal display
 *
 * @module containers/Modal
 *
 * This container renders the Search component in a modal context, positioning the component precisely and absolutely on the page
 */
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { connect } from 'react-redux';
import { Sticky } from 'react-sticky';
import { bindActionCreators } from 'redux';

import Search from '../../components/Search';
import { SearchKeys } from '../../constants';
import * as D from '../../deps';

import './SearchModal.scss';

interface ISearchModalContainerProps {
  bottomViewportPadding: number;
  injectElementsAfter: $TSFixMeFunction;
  injectElementsBefore: $TSFixMeFunction;
  isCenterPageSearch: boolean;
  isDesktopApp: boolean;
  isOnboardingPage: boolean;
  isRightRailActive: boolean;
  isSearchActive: boolean;
  navTheme: string;
  onFocusChange: $TSFixMeFunction;
  onStickyStateChange: $TSFixMeFunction;
  shouldDropSearchToNextLine: boolean;
  showColdStart: boolean;
  sticky: boolean;
  topOffset: number;
}

class SearchModalContainer extends React.Component<ISearchModalContainerProps> {
  static defaultProps = {
    /* eslint-disable */
    injectElementsAfter: (): $TSFixMe => {},
    injectElementsBefore: (): $TSFixMe => {},
    onFocusChange: (): $TSFixMe => {},
    /* eslint-enable */
    sticky: false,
  };

  componentDidUpdate(): $TSFixMe {
    if (this.props.isSearchActive) {
      D.updateAppBackground(D.Constants.App.BgSettings.APP_WHITE);
    }
  }

  onFocusChange: $TSFixMeFunction = hasFocus => {
    this.props.onFocusChange(hasFocus);
  };

  render(): $TSFixMe {
    const classes = D.Utils.Css.createBEM('SearchModalT3', {
      centerPageSearch: this.props.isCenterPageSearch && !this.props.isSearchActive,
      coldStartWelcome: this.props.showColdStart && !this.props.isOnboardingPage,
      desktopApp: this.props.isDesktopApp,
      focus: this.props.isSearchActive,
      nav:
        !this.props.showColdStart && !this.props.isOnboardingPage && !this.props.isCenterPageSearch,
      [this.props.navTheme]: !isEmpty(this.props.navTheme),
      onboarding: this.props.isOnboardingPage,
      rightRail: this.props.isRightRailActive,
      shouldDropSearchToNextLine: this.props.shouldDropSearchToNextLine,
    });
    return (
      <div className={`region-searchModal ${classes}`}>
        {this.props.injectElementsBefore()}
        {this.props.sticky && (
          <Sticky
            style={{ transform: 'none' }}
            stickyClassName='SearchStickyT3'
            topOffset={this.props.topOffset}
            onStickyStateChange={this.props.onStickyStateChange}
          >
            {/* @ts-expect-error TS(2322) FIXME: Type 'Element' is not assignable to type '((args: ... Remove this comment to see the full error message */}
            <Search {...this.props} onFocusChange={this.onFocusChange} />
          </Sticky>
        )}
        {!this.props.sticky && <Search {...this.props} onFocusChange={this.onFocusChange} />}
        {this.props.injectElementsAfter()}
      </div>
    );
  }
}

export const mapStateToProps: $TSFixMeFunction = (state: $TSFixMe, ownProps: $TSFixMe) => {
  const searchType = ownProps.searchType || SearchKeys.MAIN_SEARCH;
  // @ts-expect-error TS(2554) FIXME: Expected 0 arguments, but got 1.
  const isDesktopApp = D.Utils.ClientInfo.isElectron(state);
  const isRightRailActive = D.getInDomain('ads.utils.getIsRightRailActive', false)(state);

  // The searchT3 domain may still be initializing
  let isSearchActive;
  if (state.searchT3) {
    isSearchActive = state.searchT3.getIn([searchType, SearchKeys.SEARCH_ACTIVE]);
  }

  return {
    isDesktopApp,
    isRightRailActive,
    isSearchActive,
    navTheme: D.Utils.UIState.getNavContentTheme(state),
    searchType,
  };
};

// eslint-disable-next-line react-redux/mapDispatchToProps-returns-object
const mapDispatchToProps: $TSFixMeFunction = (dispatch: $TSFixMe) => {
  return bindActionCreators(
    {
      updateAppBackground: D.updateAppBackground,
    },
    dispatch,
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(D.determineShouldDropSearchToNextLine(SearchModalContainer));
